import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "status-badge" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Badge = _resolveComponent("Badge")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.status)
      ? (_openBlock(), _createBlock(_component_Badge, _normalizeProps({
          key: 0,
          [$options.color || ""]: true
        }), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$utils.str.capitalize($props.status)), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */))
      : _createCommentVNode("v-if", true)
  ]))
}